'use client';
import { ShieldCheck, X } from 'lucide-react';
import { useEffect, useState } from 'react';
import { cookieConsentStorage } from '@lib/localStorage';
import { Button } from '@primitive/button';

export function CookieDisclosure() {
  const [isMounted, setIsMounted] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const accepted = cookieConsentStorage.getConsent();
    if (!accepted) {
      setIsMounted(true);
      setTimeout(() => setIsVisible(true), 20);
    }
  }, []);

  const handleClose = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    cookieConsentStorage.setConsent(true); // optional, but usually desired
    setIsVisible(false);
    setTimeout(() => setIsMounted(false), 180);
  };

  if (!isMounted) return null;

  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-0 z-50 px-4 pb-6">
      <div
        className={`pointer-events-auto relative mx-auto max-w-3xl rounded-2xl border bg-background/95 shadow-xl backdrop-blur-sm transition-all duration-200 ease-out ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-3 opacity-0'
          }`}
      >
        <Button
          aria-label="Dismiss cookie notice"
          size="icon"
          variant="ghost"
          className="absolute right-2 top-2 text-muted-foreground hover:text-foreground"
          onClick={handleClose}
        >
          <X className="size-4" />
        </Button>

        <div className="flex flex-col gap-3 p-4 sm:flex-row sm:items-center sm:justify-between sm:gap-4">
          <div className="flex items-start gap-3">
            <div className="mt-0.5 rounded-lg bg-primary/10 p-2 text-primary">
              <ShieldCheck className="size-4" />
            </div>
            <div className="space-y-1 text-sm text-foreground/90">
              <p className="font-medium text-foreground">We use essential cookies</p>
              <p className="text-muted-foreground">
                Cookies keep you signed in and power core functionality. They are not used for tracking or advertising.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
